import { render } from "./RelativeDateTime.vue?vue&type=template&id=0c35cbca"
import script from "./RelativeDateTime.vue?vue&type=script&lang=js"
export * from "./RelativeDateTime.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__